import { EntTransportFilter } from "../../../models/filters/transportFilter";
import { EntTransport } from "../../../models/transport";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import moment from "moment";
import { EntTransportReportFilter } from "../../../models/filters/transportReportFilter";
import { BlobResponse } from "../../../models/report";
import { Paths } from "../../../paths";

export const transportApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTransportListAll: builder.query<ResponseDataGet<EntTransport>, EntTransportFilter>({
	  query: (filter) => ({
		url: `${Paths.mechanization.transport}/get-all`,
		method: "POST",
		body: JSON.stringify(filter, (key, value) => {
		  if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
			return moment(value).format('YYYY-MM-DD')
		  }
		  return value;
		})
	  }),
	}),

	getTransportById: builder.query<ResponseDataTest<EntTransport>, number>({
	  query: (id) => ({
		url: `${Paths.mechanization.transport}/${ id }`,
		method: 'GET'
	  })
	}),
	addTransport: builder.mutation<ResponseDataTest<EntTransport>, EntTransport>({
	  query: (body) => ({
		url: `${Paths.mechanization.transport}`,
		method: "POST",
		body: JSON.stringify(body, (key, value) => {
		  if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
			return moment(value).format('YYYY-MM-DD')
		  }
		  return value;
		})
	  }),
	}),
	editTransport: builder.mutation<ResponseDataTest<EntTransport>, EntTransport>({
	  query: (body) => ({
		url: `${Paths.mechanization.transport}`,
		method: 'PUT',
		body: JSON.stringify(body, (key, value) => {
		  if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
			return moment(value).format('YYYY-MM-DD')
		  }
		  return value;
		})
	  }),
	}),
	deleteTransport: builder.mutation<ResponseDataTest<EntTransport>, number>({
	  query: (id) => ({
		url: `${Paths.mechanization.transport}/${ id }`,
		method: 'DELETE',
	  }),
	}),
	getReportTransport: builder.mutation<any, any>({
	  query: (payload) => {
		if (payload.language === "ky") {
		  payload.language = "kg";
		}
		return {
		  url: `/departments/mechanization/report/agricultural-machinery-register?language=${ payload.language }`,
		  method: "POST",
		  body: JSON.stringify(payload),
		  responseHandler: (response) => response.blob(),
		};
	  },
	}),
	getReportWorkTransport: builder.mutation<BlobResponse, EntTransportReportFilter>({
	  query: (payload) => {
		if (payload.language === "ky") {
		  payload.language = "kg";
		}
		return {
		  url: `/departments/mechanization/report/agricultural-machinery-register-with-working?language=${ payload.language }`,
		  method: "POST",
		  body: JSON.stringify(payload),
		  responseHandler: (response) => response.blob(),
		};
	  },
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetReportWorkTransportMutation,
  useGetReportTransportMutation,
  useAddTransportMutation,
  useDeleteTransportMutation,
  useEditTransportMutation,
  useLazyGetTransportListAllQuery,
} = transportApi;
